import { createIcon } from '@chakra-ui/icons';

export const Workshop = createIcon({
  displayName: 'Workshop',
  viewBox: '0 0 27 23',
  path: [
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.48476 7.04858C2.48476 7.04858 8.37812 22.7737 15.4767 21.2885C20.9003 20.1544 23.8755 10.5979 24.9763 6.15651C25.1519 5.45425 24.312 4.94653 23.7711 5.43052L17.5598 10.9965C16.3593 12.0736 14.5372 12.0499 13.3652 10.9443L4.3211 2.4269C3.92251 2.05205 3.49071 1.71515 3.01621 1.44468C1.6354 0.642765 -0.447678 0.163515 2.48476 7.04858Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M13.4696 21.2932C14.0484 21.4118 14.5799 21.4166 15.0117 21.3644C19.1304 20.8756 14.8361 8.47209 13.721 2.48383C13.5645 1.6487 12.3972 1.58702 12.122 2.40317L8.13612 14.1756C7.65212 15.5992 7.98902 17.1745 9.01869 18.2659C10.1955 19.5138 11.8562 20.9611 13.4696 21.2932Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>,
  ],
});
